export default function Link() {
  return {
    MuiLink: {
      defaultProps: {
        underline: "none",
      },

      styleOverrides: {
        root: {},
      },
    },
  };
}
